import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyWithSpacePipe } from './currency-with-space.pipe';

@Pipe({
  name: 'protectedCurrency',
  standalone: false
})
export class ProtectedCurrencyPipe implements PipeTransform {
  constructor(private currencyWithSpacePipe: CurrencyWithSpacePipe) {}

  protected: boolean = false;

  transform(
    value: number | null | undefined,
    isProtected: boolean = false,
    currencyCode: string = ' ',
    display: 'code' | 'symbol' | 'symbol-narrow' = 'symbol',
    digitsInfo?: string,
    locale: string = 'en-US'
  ): string | null {
    if (isProtected || this.protected) {
      return '*****';
    }

    return this.currencyWithSpacePipe.transform(
      value,
      currencyCode,
      display,
      digitsInfo,
      locale
    );
  }
}
